<template>
    <el-form label-width="150px">
        <el-form-item label="教室">
            <el-input :value="form.roomName" size=""></el-input>
        </el-form-item>
        <el-form-item label="時段">
            <el-tag
                    v-for="p in form.periods"
                    :key="p.date"
                    style="margin-right: 2px;"
            >
                {{`${p.date} (${toWeekdayFmt(p.weekday)}) [${p.begin}-${p.end}]`}}
            </el-tag>
        </el-form-item>
        <el-form-item label="申請人"
        >
            {{form.applicant | prettyUsername}}
        </el-form-item>
        <el-form-item label="使用人"
        >
            {{form.realUser | prettyUsername}}
        </el-form-item>
        <el-form-item label="連絡電話"
        >
            <el-input :value="form.contact" size=""></el-input>
        </el-form-item>
        <el-form-item label="Email"
        >
            <el-input :value="form.email" size=""></el-input>
        </el-form-item>
        <el-form-item label="事由"
        >
            <el-input type="textarea" :value="form.reason" size="" v-if="form.notForCourseOrExam"></el-input>
            <el-input :value="`${form.byAdmin ? '' : '(上課/考試)'}${form.reason}`" size="" v-else></el-input>
        </el-form-item>
    </el-form>
</template>

<script>

    import moment from 'moment';
    import {Weekdays} from '../constants';

    const defaultForm = {
        applicant: {},
        realUser:{},
        notForCourseOfExam: false,
        contact: '',
        periods: [],
        email:'',
        roomName:'',
        roomId:'',
        reason:'',
        byAdmin: false,
    };
    export default {
        name: 'FormDetail',
        props: {
            form: {
                type: Object,
                required: true,
                default: () => ({...defaultForm})
            }
        },
        filters: {
            shortDate(date) {
                if (date) {
                    return moment(date).format('YYYY-MM-DD');
                }
                return '';
            }
        },
        methods:{
            toWeekdayFmt(weekday){
                return  Weekdays[weekday];
            }
        }
    }
</script>

<style scoped>

</style>